
import { Component, Vue } from "vue-property-decorator";
import MoqupLots from "@/views/moqups/building/Lots.vue";

@Component({
  components: {
    MoqupLots,
  },
})
export default class Batiment extends Vue {

  private tab: "EQUIPMENT" | "LOTS" = "LOTS";

  private changeTabs(tab) {
    this.tab = tab;
  }
}
